const Home = () => {
  return <></>;
};

export default Home;
